import { render, staticRenderFns } from "./TextStatus.vue?vue&type=template&id=66709e59&"
import script from "./TextStatus.vue?vue&type=script&lang=js&"
export * from "./TextStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports